import { put, takeLatest } from "redux-saga/effects";

import {
  fetchrentalInvoiceBillsListRequest,
  fetchrentalInvoiceBillsListSuccess,
  fetchrentalInvoiceBillsListFailure,
  rentalInvoiceBillsCreateRequest,
  rentalInvoiceBillsCreateSuccess,
  rentalInvoiceBillsCreateFailure,
  rentalInvoiceBillsUpdateRequest,
  rentalInvoiceBillsUpdateSuccess,
  rentalInvoiceBillsUpdateFailure,
  rentalInvoiceBillsDeleteRequest,
  rentalInvoiceBillsDeleteSuccess,
  rentalInvoiceBillsDeleteFailure,
  rentalReportUpdateStatusRequest,
  rentalReportUpdateStatusSuccess,
  rentalReportUpdateStatusFailure,
  fetchrentalBillsListRequest,
  fetchrentalBillsListSuccess,
  fetchrentalBillsListFailure,
  rentalBillsCreateRequest,
  rentalBillsCreateSuccess,
  rentalBillsCreateFailure,
  rentalBillsUpdateRequest,
  rentalBillsUpdateSuccess,
  rentalBillsUpdateFailure,
} from "redux/reducers/acclgl/rental-bills";
import {
  requestRentalInvoiceBillsList,
  requestRentalInvoiceBillsCreate,
  requestRentalInvoiceBillsUpdate,
  requestDeleteRentalItem,
  requestRentalReportUpdateStatus,
  requestRentalBillsList,
  requestRentalBillsCreate,
  requestRentalBillsUpdate,
} from "services/acclgl/rental-bills";

export function* watchRentalBills() {
  yield takeLatest(
    fetchrentalInvoiceBillsListRequest,
    fetchrentalInvoiceBillslist
  );
  yield takeLatest(rentalInvoiceBillsCreateRequest, rentalInvoiceBillsCreate);
  yield takeLatest(rentalInvoiceBillsUpdateRequest, rentalInvoiceBillsUpdate);
  yield takeLatest(rentalInvoiceBillsDeleteRequest, rentalInvoiceBillsDelete);
  yield takeLatest(rentalReportUpdateStatusRequest, rentalReportUpdateStatus);

  yield takeLatest(fetchrentalBillsListRequest, fetchrentalBillsList);
  yield takeLatest(rentalBillsCreateRequest, rentalBillsCreate);
  yield takeLatest(rentalBillsUpdateRequest, rentalBillsUpdate);
}

function* fetchrentalInvoiceBillslist({ payload }) {
  try {
    const response = yield requestRentalInvoiceBillsList(payload);
    yield put(fetchrentalInvoiceBillsListSuccess(response));
  } catch (error) {
    yield put(fetchrentalInvoiceBillsListFailure("Failed to get list"));
  }
}

function* rentalInvoiceBillsCreate({ payload }) {
  try {
    const response = yield requestRentalInvoiceBillsCreate(payload);
    yield put(rentalInvoiceBillsCreateSuccess(response.data));
  } catch (error) {
    yield put(rentalInvoiceBillsCreateFailure("Failed to get list"));
  }
}

function* rentalInvoiceBillsUpdate({ payload }) {
  try {
    const response = yield requestRentalInvoiceBillsUpdate(payload);
    yield put(rentalInvoiceBillsUpdateSuccess(response.data));
  } catch (error) {
    yield put(rentalInvoiceBillsUpdateFailure("Failed to get list"));
  }
}

function* rentalInvoiceBillsDelete({ payload }) { 
  try {
    const response = yield requestDeleteRentalItem(payload);
    yield put(rentalInvoiceBillsDeleteSuccess(response.data));
  } catch (error) {
    yield put(rentalInvoiceBillsDeleteFailure("Failed to get list"));
  }
}

function* rentalReportUpdateStatus({ payload }) {
  try {
    const response = yield requestRentalReportUpdateStatus(payload);
    yield put(rentalReportUpdateStatusSuccess(response));
    // yield put(rentalReportUpdateStatusSuccess(response.data));
  } catch (error) {
    yield put(rentalReportUpdateStatusFailure("Failed to Update list"));
  }
}

// rental bills 
function* fetchrentalBillsList({ payload }) {
  try {
    const response = yield requestRentalBillsList(payload);
    yield put(fetchrentalBillsListSuccess(response));
  } catch (error) {
    yield put(fetchrentalBillsListFailure("Failed to get list"));
  }
}

function* rentalBillsCreate({ payload }) {
  try {
    const response = yield requestRentalBillsCreate(payload);
    yield put(rentalBillsCreateSuccess(response.data));
  } catch (error) {
    yield put(rentalBillsCreateFailure("Failed to get list"));
  }
}

function* rentalBillsUpdate({ payload }) {
  try {
    const response = yield requestRentalBillsUpdate(payload);
    yield put(rentalBillsUpdateSuccess(response.data));
  } catch (error) {
    yield put(rentalBillsUpdateFailure("Failed to get list"));
  }
}